<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <router-link :to="{ name: `${selectedLanguage}-gb` }" title="GBWhatsApp" rel="home">
          <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/logo.webp" title="GBWhatsApp">
        </router-link>
      </div>
      <p class="main-title" itemprop="headline">
        <router-link :to="{ name: `${selectedLanguage}-gb` }" rel="home">
          GBDownloads
        </router-link>
      </p>
    </div>
    <ul id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
      <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
        <router-link :to="{ name: `${selectedLanguage}-gb` }" class="download-btn">GBWhatsApp</router-link>
      </li>
      <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
        <router-link to="/download/" class="download-btn">Download</router-link>
      </li>
      <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
        <router-link to="/blog/" class="download-btn">Blogs</router-link>
      </li>
      <li v-if="showLangSwitcher" class="menu-item menu-item-type-custom menu-item-language">
        <div class="language-selector">
          <select id="language-select" :value="selectedLanguage" @change="changeLanguage($event.target.value)">
            <option v-for="item in homeLangOptions" :key="item.lang" :value="item.lang">{{ item.val }}</option>
          </select>
        </div>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <!-- mobile -->
      <div class="mobile-menu" v-if="$global.isMobileDevice()">
        <div v-if="showLangSwitcher" class="language-selector">
          <select id="language-select" :value="selectedLanguage" @change="changeLanguage($event.target.value)">
            <option v-for="item in homeLangOptions" :key="item.lang" :value="item.lang">{{ item.val }}</option>
          </select>
        </div>
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="close button" v-else>
        </div>
      </div>
      <!-- pc -->
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <router-link :to="{ name: `${selectedLanguage}-gb` }" class="download-btn">GBWhatsApp</router-link>
        </li>
        <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <router-link to="/download/" class="download-btn">Download</router-link>
        </li>
        <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <router-link to="/blog/">Blogs</router-link>
        </li>
        <li v-if="showLangSwitcher" class="menu-item menu-item-type-custom menu-item-language">
          <div class="language-selector">
            <select id="language-select" :value="selectedLanguage" @change="changeLanguage($event.target.value)">
              <option v-for="item in homeLangOptions" :key="item.lang" :value="item.lang">{{ item.val }}</option>
            </select>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  data() {
    return {
      isMenuClicked: false,
      homeLangOptions: [
        { lang: 'en', val: '🇺🇸 English' },
        { lang: 'pt', val: '🇵🇹 Português' },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
        },
      },
    }
  },
  computed: {
    // 仅在首页展示 en/pt 切换
    showLangSwitcher() {
      return this.page === 'gb';
    },
  },
  methods: {
    changeLanguage(lang) {
      if (!lang || lang === this.selectedLanguage) {
        return;
      }
      this.$router.push({
        name: `${lang}-${this.page}`,
      });
    },
    download() {
      if (typeof this.gotodownload === 'function') {
        this.gotodownload();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.language-selector {
  display: flex;
  align-items: center;

  #language-select {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 14px;
    background: #fff;
    cursor: pointer;
    min-width: 130px;
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;
    display: flex;
    align-items: center;
    gap: 8px;

    li {
      a {
        font-weight: 500 !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #fff;

        a, div {
          font-size: 15px;
          text-align: center;
          color: #121212;
          display: block;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      position: relative;
      gap: 8px;

      .language-selector {
        width: auto;

        #language-select {
          width: 120px;
        }
      }

      .menu-toggle {
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
